import type { JSX } from "react";
import { Icon } from "./Icon";
import { Row } from "./Row";
import { Text } from "./Text";

export interface NavArrowsProps {
  /** Center label (e.g. date range) */
  readonly label: string;
  /** Extra className */
  readonly className?: string;
  /** Previous click handler */
  readonly onPrev?: () => void;
  /** Next click handler */
  readonly onNext?: () => void;
}

/**
 * Previous / label / next arrow navigation row.
 * Used in calendar week-view navigation.
 */
export function NavArrows({ label, className, onPrev, onNext }: NavArrowsProps): JSX.Element {
  return (
    <Row gap={3} align="center" justify="center" className={className}>
      <button
        className="w-6 h-6 rounded border border-edge inline-flex items-center justify-center bg-transparent text-content-secondary cursor-pointer rotate-180"
        type="button"
        onClick={onPrev}
      >
        <Icon name="chevron-right" size={13} />
      </button>
      <Text variant="body">{label}</Text>
      <button
        className="w-6 h-6 rounded border border-edge inline-flex items-center justify-center bg-transparent text-content-secondary cursor-pointer"
        type="button"
        onClick={onNext}
      >
        <Icon name="chevron-right" size={13} />
      </button>
    </Row>
  );
}
